<template>
	<div>
		<el-form inline style="margin-top:20px">
			<el-form-item label="">
				<el-input v-model="keyword" placeholder="请输入搜索内容" size='medium' clearable @input="search" />
			</el-form-item>
			<el-form-item label="">
				<el-button type='primary' size='medium' @click="$refs.recordTagFormRef.add()">新增标签</el-button>
			</el-form-item>
		</el-form>

		<el-table ref="tableRef" :key="tableKey" :data="tagNodeList" :tree-props="{children: 'children'}"
			:default-expand-all="expand" row-key="id" height="calc(100% - 160px)">
			<el-table-column label="名称" prop="name" show-overflow-tooltip />
			<el-table-column label="适用年级" :formatter="levelFormatter" show-overflow-tooltip />
			<el-table-column label="描述" prop="description" show-overflow-tooltip="" />
			<el-table-column label="操作">
				<template v-slot="{row}">
					<el-button type='text' size='mini' @click="$refs.recordTagFormRef.edit(row)">编辑</el-button>
					<el-button type='text' size='mini' @click="$refs.recordTagFormRef.add(row.id,row.level)">添加下级</el-button>
					<el-button type='text' size='mini' @click="remove(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<record-tag-form ref="recordTagFormRef"  />
	</div>
</template>

<script>
	import { recordTagApi } from '@/boot-api/record'
	import RecordTagCascader from '@/views/record/record-tag-cascader.vue'
	import RecordTagForm from './record-tag-form.vue';
	import { mapState } from 'vuex'

	export default {

		components: { RecordTagCascader, RecordTagForm },
		data() {
			return {
				nodes: [],
				keyword: '',
				resultList: [],
				expand: false,
				tableKey: 'list'
			}
		},
		computed: {
			...mapState('record', {
				tagNodeList(state) {
					console.log('===22=>',state.tagNodeList,this.tableKey)
					if (this.tableKey == 'search') {
						return this.resultList
					} else {
						return state.tagNodeList
					}
				}
			}),
			...mapState('school', {
				gradeList(state) {
					let l = state.gradeList.map(e => {
						e.label = e.name + '班阶段'
						return e
					});
					return [{ id: 0, label: "全年级" }].concat(l)
				}
			})

		},
		// watch:{
		// 	tagNodeList(v){
		// 		this.tagNodeList=v
		// 	}
		// },
		methods: {
			levelFormatter(row){
				const grade=this.gradeList.find(v=>v.id==row.level);
				return grade?grade.label:'-'
			},
			getNodeList() {
				this.$store.dispatch('record/getTagNodeList')
			},
			async remove(tag) {
				const hasResult = await recordTagApi.hasChildren({ id: tag.id })
				const msg = hasResult.data ? `"${tag.name}" 标签下存在子标签，删除将一并删除所有的子标签` : `确定删除当前标签"${tag.name}"`
				this.$confirm(msg, '提示', {
					confirmButtonText: '删除'
				}).then(async () => {
					await recordTagApi.remove({ id: tag.id, force: hasResult.data })
					this.$message.success('移除成功')
					this.getNodeList()
				}).catch(() => { })

			},

			search(keyword) {
				if (keyword == '') {
					this.expand = false
					this.resultList = []
					this.tableKey = 'list'
					return
				}
				this.resultList = []
				const list = this.$store.state.record.tagNodeList
				list.forEach(node => this.nodeSearch(node, keyword))
				this.expand = true
				this.tableKey = 'search'
			},

			nodeSearch(node, keyword) {
				let snode = {
					id: node.id,
					parentId: node.parentId,
					name: node.name,
					description: node.description,
					children: node.children
				}
				if (snode.children) {
					snode.children.forEach(n => {
						this.nodeSearch(n, keyword)
					});
				}
				snode.children = this.resultList.filter(v => v.parentId == snode.id)
				this.resultList = this.resultList.filter(v => v.parentId != snode.id)
				if (snode.name.includes(keyword) || snode.children.length > 0) {
					this.resultList.push(snode)
				}
			}

		},



		mounted() {
			this.getNodeList()
		}
	};
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/record/set/tag.vue